import { Configuration } from '@azure/msal-browser';
import { environment } from './build';

// Function to determine the redirect URI based on the environment
const getRedirectUri = () => {
  const origin = window.location.origin;
  if (environment === 'production') {
    return `${origin}/ons/`;
  } else if (environment.startsWith('local')) {
    return `${origin}/`;
  } else {
    return `${origin}/ons/`;
  }
};

// MSAL Configuration object containing authentication and cache settings
export const msalConfig: Configuration = {
  auth: {
    // Client ID obtained from Azure Active Directory App Registration
    clientId: '6e247537-b8b6-4d31-84a0-7d1f99ec3ba2',
    // Authority URL for authentication
    authority: 'https://login.microsoftonline.com/741bf7de-e2e5-46df-8d67-82607df9deaa',
    // Redirect URI based on the environment
    redirectUri: getRedirectUri(),
    // Post-logout redirect URI
    postLogoutRedirectUri: getRedirectUri(),
    navigateToLoginRequestUrl: true
  },
  cache: {
    // Cache location in the browser storage
    cacheLocation: 'localStorage'
  }
};
